import React from 'react';

interface MetricCardProps {
  label: string;
  value: string;
  unit?: string;
  subtext?: string;
  icon?: React.ReactNode;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  color?: string;
  highlight?: boolean;
  className?: string;
  children?: React.ReactNode;
}

export default function MetricCard({
  label,
  value,
  unit,
  subtext,
  icon,
  color = 'var(--accent-cyan)',
  highlight = false,
  className = '',
  children,
}: MetricCardProps) {
  return (
    <div
      className={`rounded-xl p-4 flex flex-col gap-2 transition-all duration-200 hover:border-opacity-60 ${className}`}
      style={{
        backgroundColor: 'var(--card)',
        border: `1px solid ${highlight ? color + '66' : 'var(--card-border)'}`,
        boxShadow: highlight ? `0 0 20px ${color}15` : 'none',
      }}
    >
      <div className="flex items-center justify-between">
        <span
          className="text-xs font-medium uppercase tracking-widest"
          style={{ color: 'var(--text-secondary)', letterSpacing: '0.08em' }}
        >
          {label}
        </span>
        {icon && (
          <span style={{ color }}>{icon}</span>
        )}
      </div>
      <div className="flex items-end gap-1.5">
        <span
          className="font-mono-data font-bold leading-none"
          style={{ color, fontSize: '28px' }}
        >
          {value}
        </span>
        {unit && (
          <span className="text-sm font-medium mb-0.5" style={{ color: 'var(--text-secondary)' }}>
            {unit}
          </span>
        )}
      </div>
      {subtext && (
        <p className="text-xs" style={{ color: 'var(--text-muted)' }}>{subtext}</p>
      )}
      {children}
    </div>
  );
}
